interface IAppConstants {
  mobileMax: number;
  tabletMax: number;
}

export const AppConstants: IAppConstants = {
  mobileMax: 428,
  tabletMax: 768
};
